module.exports = ".warn{\r\n    border:solid 1px red !important;\r\n}"